import { EmployeesEffects } from './employees.effect';
import { OfficesEffects } from './offices.effect';
import { PositionsEffects } from './positions.effect';

export const effects = [EmployeesEffects, PositionsEffects, OfficesEffects];
export * from './employees.effect';
export * from './positions.effect';
export * from './offices.effect';
